<template>
  <yxtf-row v-loading="loading" :gutter="40" class="yxtbiz-knginfo font-size-14">
    <yxtf-col :span="24" class="font-size-16 lh24">{{ $t('biz_lbl_knginfo'/** 知识信息 */) }}</yxtf-col>
    <yxtf-col
      v-for="item of colList"
      :key="item.key"
      :span="12"
      class="mt24 nowrap"
    >
      <label class="pull-left color-gray-7">{{ item.label }}：</label>
      <yxtf-tooltip class="" open-filter :content="item.value" placement="top">
        <div class="nowrap ellipsis">{{ item.value }}</div>
      </yxtf-tooltip>
    </yxtf-col>
    <yxtf-col :span="24" class="mt24">
      <yxtf-link type="primary" :underline="false" @click="openDetail">{{ $t('biz_lbl_previewkng'/** 查看知识详情 */) }}</yxtf-link>
    </yxtf-col>
  </yxtf-row>
</template>

<script>
import { getKngInfo, getOrgtags } from './service.js';
export default {
  name: 'YxtbizKngInfo',
  name_zh: '知识库知识审核',
  props: {
    id: {
      type: String,
      required: true,
      desc: '知识id',
      setter: 'StringSetter'
    }
  },
  data() {
    this.emptyValue = '--';
    return {
      loading: true,
      colList: [
        { label: this.$t('pc_biz_knglib_lbl_libName'/** 所属知识库 */), value: this.emptyValue, key: 'rootLibName' },
        { label: this.$t('biz_lbl_uploadfolder'/** 上传文件夹 */), value: this.emptyValue, key: 'libName' },
        { label: this.$t('pc_biz_lbl_kngname'/** 知识名称 */), value: this.emptyValue, key: 'title' },
        { label: this.$t('biz_lbl_kngdesc'/** 知识简介 */), value: this.emptyValue, key: 'description' },
        { label: this.$t('biz_lbl_kngtag'/** 知识标签 */), value: this.emptyValue, key: 'tagNames' }
      ]
    };
  },
  watch: {
    id: {
      immediate: true,
      handler() {
        this.getData();
      }
    }
  },
  methods: {
    getData() {
      this.loading = true;
      this.promiseAllSettled([getKngInfo(this.id), getOrgtags(this.id)]).then(res => {
        if (res[0].status === 'rejected') {
          let msg = this.$t('common_msg_unknowError');
          try {
            msg = res[0].reason.error.message;
          } catch (error) {
          }
          this.colList.forEach(item => { item.value = this.emptyValue; });
          return this.$message.error(msg);
        }
        let info = res[0].value;
        if (res[1].status === 'fulfilled') {
          try {
            info.tagNames = res[1].value.datas.map(item => item.tagName).join('、');
          } catch (error) {
          }
        }
        this.colList.forEach(item => {
          if (item.key === 'libName' && info.libId === info.rootLibId) {
            // 上传文件夹,需要处理根目录
            item.value = this.$t('pc_biz_lbl_rootfolder'/** 根目录 */);
          } else {
            item.value = info[item.key] || this.emptyValue;
          }
        });
        // 文件在私有云
        if (info.storageLocationName) {
          let storageLocationNameCol = this.colList.find(item => item.key === 'storageLocationName');
          if (storageLocationNameCol) {
            storageLocationNameCol.value = info.value;
          } else {
            this.colList.unshift({
              label: this.$t('biz_lbl_storageserver'/** 存储区域 */),
              value: info.storageLocationName,
              key: 'storageLocationName'
            });
          }
        }
      }).then(() => {
        this.loading = false;
      });
    },
    openDetail() {
      window.open(`/knglib/#/detail/audit?kngId=${this.id}`);
    },
    promiseAllSettled(arr, useReject) {
      // if (window.Promise && window.Promise.allSettled) {
      //   return window.Promise.allSettled(arr)
      // }
      let [result, _resolve, _reject] = [[]];
      function checkAll() {
        // 如果有请求未返回
        if (result.some(item => item === null)) {
          return;
        }
        let allFail = false;
        // 所有请求都失败
        if (result.every(item => item.status === 'rejected')) {
          allFail = true;
        }
        // 所有请求都失败了，并且要求抛出异常
        if (useReject && allFail) {
          _reject(result);
        } else {
          _resolve(result);
        }
      };
      arr.forEach((ajax, index) => {
        result.push(null);
        ajax.then(res => {
          result[index] = { status: 'fulfilled', value: res };
        }).catch(e => {
          result[index] = { status: 'rejected', reason: e };
        }).then(() => {
          checkAll();
        });
      });
      return new Promise((resolve, reject) => {
        _resolve = resolve;
        _reject = reject;
      });
    }
  }
};
</script>
